import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { SelectedItem } from '@app/models/client/item.model';
import {
  ContainerItemModel,
  ContainerItemOption,
} from '@app/models/server/layout.model';
import { Subscription } from 'rxjs';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
// import { LoggerService } from '@app/services/util-services/logger.service';
import {
  NgClass,
  NgOptimizedImage,
  SlicePipe,
  TitleCasePipe,
} from '@angular/common';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-b2b-new-radio-checkbox-list',
  templateUrl: './b2b-new-radio-checkbox-list.component.html',
  styleUrls: ['./b2b-new-radio-checkbox-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitleCasePipe, SlicePipe, NgClass, NgOptimizedImage],
})
export class B2bNewRadioCheckboxListComponent implements OnInit, OnDestroy {
  initialValues: SelectedItem[] = [];
  selectedIds: string[] = [];

  limitTo: number;
  displayShowLess: boolean = Boolean(false);

  displayOptions: ContainerItemOption[] = [];

  protected readonly environment = environment;

  isCollapsed: boolean = Boolean(false);
  clearAllFilterEventSubscribe$: Subscription;
  resetIndividualFilterSubscription$: Subscription;
  @Input() compData: {
    containerItem: ContainerItemModel;
    preSelectedValues: { [key: string]: any };
  };

  @Output() selectEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private eventService: EventService,
    private analyticsEventService: AnalyticsEventService,
    private cdRef: ChangeDetectorRef,
  ) {
    this.resetIndividualFilterSubscription$ =
      this.eventService.resetIndividualFilterEvent.subscribe({
        next: (result: any) => {
          // LoggerService.log(
          //   'Inside this.eventService.resetIndividualFilterEvent.subscribe'
          // );
          this.selectedIds = [];
          this.initialValues = [];
          this.cdRef?.detectChanges();
        },
      });

    this.clearAllFilterEventSubscribe$ =
      this.eventService.clearAllFilterEvent.subscribe({
        next: (result: any) => {
          // LoggerService.log(
          //   'Inside this.eventService.clearAllFilterEvent.subscribe'
          // );
          this.selectedIds = [];
          this.initialValues = [];
          this.cdRef?.detectChanges();
        },
      });
  }

  ngOnInit() {
    this.setDefaultOptions();
    this.setLimit();
    this.setSearchBar();

    // LoggerService.log('this.compData ', this.compData);

    /*LoggerService.log(
              'this.compData?.preSelectedValues ',
              this.compData?.preSelectedValues
            );*/

    if (
      this.compData?.preSelectedValues &&
      this.compData?.preSelectedValues[this.compData?.containerItem?.uid]
        ?.length > 0
    ) {
      /*LoggerService.log('this.displayOptions ', this.displayOptions);
                  LoggerService.log(
                    'selected values this.compData?.preSelectedValues ',
                    this.compData?.preSelectedValues[this.compData?.containerItem?.uid]
                  );*/
      this.initialValues =
        this.compData.preSelectedValues[this.compData?.containerItem?.uid];
      this.selectedIds = this.initialValues?.map((i) => i?._id + '');

      /*LoggerService.log('this.initialValues ', this.initialValues);
                  LoggerService.log('this.selectedIds ', this.selectedIds);*/
    }
  }

  setLimit() {
    if (this.compData?.containerItem?.limitTo > 0) {
      this.limitTo = this.compData?.containerItem?.limitTo;
    } else {
      // TODO: remove this code in future
      this.limitTo = 5;
      // TODO: Enable this code in future
      // this.limitTo = this.compData?.containerItem?.options?.length;
    }
  }

  setSearchBar() {
    this.compData.containerItem.showSearchBar = true;
  }

  setDefaultOptions() {
    if (this.compData?.containerItem?.options?.length > 0) {
      this.displayOptions = JSON.parse(
        JSON.stringify(this.compData?.containerItem?.options),
      );
    }
  }

  onItemClickFunc(option: ContainerItemOption, index: number): void {
    this.analyticsEventService.fireAnalyticsEvent.emit({
      eventName: option?.type?.toLowerCase(),
      data: option?.title,
    });

    if (this.selectedIds?.includes(option._id + '')) {
      this.selectedIds.splice(this.selectedIds.indexOf(option._id + ''), 1);
      this.initialValues = this.initialValues.filter((item: SelectedItem) => {
        return String(item._id) !== String(option._id);
      });
    } else {
      this.selectedIds = [option?._id + ''];
      this.initialValues = [this.setSelectedItem(option)];
    }
    // LoggerService.log('this.initialValues ', this.initialValues);
    this.selectEvent.emit(this.initialValues);
  }

  setSelectedItem(option: ContainerItemOption): SelectedItem {
    const initialValue: SelectedItem = {
      _id: option?._id + '',
      title: option?.title,
      description: option?.description,
      value: option,
      fieldConfig: {
        uid: this.compData?.containerItem?.uid,
        name: this.compData?.containerItem?.name,
      },
    };

    return initialValue;
  }

  onShowAll(): void {
    this.limitTo = this.compData?.containerItem?.limitTo;
    this.displayShowLess = true;
  }

  resetShowLess(): void {
    this.displayShowLess = false;
  }

  onShowLess(): void {
    if (this.compData?.containerItem?.limitTo > 0) {
      this.limitTo = this.compData?.containerItem?.limitTo;
    } else {
      // TODO remove this code in future
      this.limitTo = 5;
    }
    this.displayShowLess = false;
  }

  onTextChangeFunc(event: string): void {
    // LoggerService.log(
    //   'onTextChangeFunc event.target.value ',
    //   event.target.value
    // );
    const val: string = event;
    if (val && val !== '' && val?.trim() !== '') {
      this.analyticsEventService.fireTextSearch(val);

      this.displayOptions = this.compData?.containerItem?.options?.filter(
        (item: ContainerItemOption) => {
          return (
            (item.title as string).toLowerCase().indexOf(val.toLowerCase()) > -1
          );
        },
      );
    } else {
      this.setDefaultOptions();
    }
    this.onShowAll();
    this.resetShowLess();
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  ionViewDidLeave() {
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.resetIndividualFilterSubscription$) {
      this.resetIndividualFilterSubscription$.unsubscribe();
    }
    if (this.clearAllFilterEventSubscribe$) {
      this.clearAllFilterEventSubscribe$.unsubscribe();
    }
  }
}
